module.exports = __webpack_public_path__ + "static/media/tools.ac4637ee.png";